import type { ObservationOrigin } from '@liza/fhir-utils';
import type { TFunction } from 'i18next';

/**
 * What to call a reading's origin when it does not name a source of its own.
 *
 * The chart marks provenance by fill — filled for a measured reading, hollow for a hand-typed one —
 * and neither care-plan chart carries a permanent legend, so the tooltip is where that mark is
 * explained. A reading that names its writer ("Quest Diagnostics", "Apple Health") says enough on its
 * own; this is the fallback for one that does not, and the only thing a hand-typed reading ever shows.
 *
 * A switch rather than a key built from the origin, so every key is a literal `t()` argument the
 * extractor can see — a computed key would be pruned from both catalogs on the next commit.
 */
export const observationOriginLabel = (t: TFunction<'records'>, origin: ObservationOrigin): string => {
  switch (origin) {
    case 'device':
      return t('observationSource.deviceUnnamed');
    case 'clinical':
      return t('observationSource.clinical');
    case 'entered':
    default:
      return t('observationSource.entered');
  }
};
